module.exports = __webpack_public_path__ + "static/media/24UHCHR11.d176ad0f.jpg";